import { Injectable } from '@angular/core';
import { replace, runtimeEventManager, stringStartsWith} from '@wm/core';
import { BaseVariableService, getVariableServiceType, BaseVariablePropertyFactoryService, isEventCallbackVariable, isSpinnerType, VARIABLE_CONSTANTS, getByContext, getDuplicateVariables, getAll } from '@wms/variables';
import { BaseComponent } from '@wms/app/components';
import { find, forEach, includes, keys, get, capitalize, cloneDeep, isEmpty, isNil, isFunction, isEqual } from 'lodash-es';
import { StudioUtils, WIDGET_CONSTANTS, byType, getClonedObject, isDuplicateName } from '@wms/app/core';
import { FileService, DialogService, TypeFactoryService, BindTreeUtilsService, BindVariableService, PageService, NotificationService, ServiceFactoryService } from '@wms/services';
import { Subject } from 'rxjs';
import {IssuesService} from "@wms/app/bottom-left-menu/components/issues/issues.service";

@Injectable({
  providedIn: 'root'
})
export class VariableCrudManagerService extends BaseComponent {
  propertyGroups: any;
  navigationTypes: string[] = ['pageName', 'tabName', 'accordionName', 'segmentName'];
  initVariableObj: any;
  variableChanged: any;
  variableOwnerProxy: any;
  variableNameProxy: any;
  showContinueMsg: any;
  selectedVarService: any;
  selectedVariableCategory: any;
  showPrimaryProps: any = true;
  entities: any;
  splitSource: any;
  ownerApp: any = VARIABLE_CONSTANTS.OWNER.APP;
  ownerPage = VARIABLE_CONSTANTS.OWNER.PAGE;
  pageSpinnerWidgets: any = {};
  variableList: any;
  continueMessage: any;
  preSelectedVariable: any;
  addVariableDialogMsg: any;
  currentSelectedTabView: any;
  groups: any;
  map: any = {};
  changeOwnerSubject: any = new Subject();

  constructor(private baseVariableService: BaseVariableService, private propertyFactory: BaseVariablePropertyFactoryService, private issuesService: IssuesService,private serviceFactory: ServiceFactoryService,
    private fileService: FileService, private dialogService: DialogService, private bindVariableService: BindVariableService,
    private bindTreeService: BindTreeUtilsService, private typeService: TypeFactoryService, private pageService: PageService, private notificationService: NotificationService) {
    super();
    this.groups = this.propertyFactory.getPropertyGroups();
    // TODO: add this changes in page workspace
    // this.registerDestroyListener.add(runtimeEventManager.on('save-variables').subscribe(() => {
    //   this.saveAndClose(true, true, true);
    // }));
    this.eventManager.updateVariableTreeObs().subscribe((variable: any) => {
      this.updateVariablesTree(variable);
    });
  }

  changeOwnerObs() {
    return this.changeOwnerSubject.asObservable();
  }

  /* function to save the variables in file system */
  saveVariablesInfo(openScript?: boolean, updateVariables?: boolean) {
    return new Promise<void>((resolve, reject) => {
      /* validate the selected variable */
      let validation: any = this.validateSelectedVariable(),
        requiredVariableObject: any = {},
        selectedVariable: any,
        variableName,
        variableOwner,
        updateVariableTree = false,
        collectionName,
        currentContext,
        VariableConfig,
        refreshWS: any;

      /* if error occurred while validating simply return */
      if (validation.showError) {
        this.updateMessageContent('error', validation.errorMsg);
        return reject();
      }

      /* show loading message */
      this.updateMessageContent('loading', this.locale.MESSAGE_SAVE_VARIABLE);


      /* transform the created variable in format required by service */
      selectedVariable = this.baseVariableService.selectedVariable;
      variableName = selectedVariable.variableObject.name;
      variableOwner = (selectedVariable.variableObject.owner === this.ownerApp) ? this.ownerApp : this.pageService.activePageName;
      if (selectedVariable.variableObject.category === 'wm.LiveVariable' && !selectedVariable.variableObject["filterExpressions"]) {
        selectedVariable.variableObject["filterExpressions"] = {};
      }
      requiredVariableObject = getClonedObject(selectedVariable.variableObject);
      requiredVariableObject.category = selectedVariable.category;
      let varOldName = requiredVariableObject._oldName;
      /*Remove unwanted properties*/
      requiredVariableObject._oldName = undefined;
      requiredVariableObject._isUpdated = undefined;
      requiredVariableObject.active = undefined;
      if (this.baseVariableService.variableInstanceCollection[variableOwner][varOldName] && !this.baseVariableService.variableInstanceCollection[variableOwner][variableName]) {
        this.baseVariableService.variableInstanceCollection[variableOwner][variableName] = this.baseVariableService.variableInstanceCollection[variableOwner][varOldName];
        delete this.baseVariableService.variableInstanceCollection[variableOwner][varOldName];
      }
      /* save unsaved variables first if there is one*/
      if (this.baseVariableService.unsavedVariable) {
        this.baseVariableService.storeUnsavedVariable();
      }

      // TO DO - needed?
      // if (selectedVariable.category === 'wm.DeviceVariable') {
      //   /* enable permission for device variables */
      //   VariableConfig = DeviceVariableService.getOperation(selectedVariable.variableObject.service, selectedVariable.variableObject.operation);

      //   if ($rootScope.isNativeMobileApplicationType && VariableConfig.requiredNativePlugins) {
      //     ProjectService.addNativePlugins($rootScope.project.id, VariableConfig.requiredNativePlugins);
      //   } else if (VariableConfig.requiredCordovaPlugins) {
      //     ProjectService.addCordovaPlugins($rootScope.project.id, VariableConfig.requiredCordovaPlugins);
      //   }
      //   if (selectedVariable.variableObject.operation === 'getNetworkInfo' && _.get(selectedVariable.variableObject, 'owner') === 'App') {
      //     requiredVariableObject.dataBinding.find(function (prop) {
      //       // only include app.networkStatus for page-level variables not app variable. so overriding the value.
      //       if (prop.target === 'networkStatus') {
      //         prop.value = 'bind:networkStatus';
      //         return true;
      //       }
      //     });
      //   }
      // }

      if (requiredVariableObject.service === 'file') {
        /* register the file-upload-device variable */
        (this.serviceFactory.isFileServiceRegistered() as Promise<any>).then((isFileReg: boolean) => {
          if (!isFileReg) {
            this.fileService.registerFileService();
          }
        });
      }

      /* store it and add it in tree only if its a new variable */
      if (selectedVariable.isNew) {
        updateVariableTree = true;
        /* Store the variable in proper category */
        this.baseVariableService.store(variableOwner, variableName, requiredVariableObject, this.baseVariableService.createOnly, this.baseVariableService.createOnly);
      } else {
        this.updateMessageContent('loading', this.locale.MESSAGE_SAVE_VARIABLE);
      }

      /* check for deleted variables */
      try {
        currentContext = [this.variableList[VARIABLE_CONSTANTS.OWNER.APP], this.variableList[this.pageService.activePageName]];
        forEach(currentContext, (variables) => {
          forEach(variables, (variable, name) => {
            /*Remove unwanted property*/
            variable.active = undefined;
            variable._deprecated = undefined;
            if (includes(getDuplicateVariables(), name)) {
              updateVariableTree = true;
            }
            /*Check for variable updating*/
            if ((variable._isUpdated || variable._oldName || variable._prevOwner) && !variable.remove) {
              variable._isUpdated = undefined;
              collectionName = variable._oldName || variable.name;
              if (variable._oldName) {
                // TODO
                // refreshWS = true;
                variable._oldName = undefined;
              }
              if (variable._prevOwner) {
                // TODO
                // refreshWS = true;
                variable._prevOwner = undefined;
              }
              this.baseVariableService.updateVariable(collectionName, variable);
              updateVariableTree = true;
            }
            /*Check for variable deletion*/
            if (variable.remove) {
              var owner;
              // Check if the previous owner for the variable being deleted exists,
              // if the previous owner exists use that else use the current owner.
              if (variable._prevOwner) {
                owner = variable._prevOwner;
              } else {
                owner = variable.owner === 'App' ? 'App' : this.pageService.activePageName;
              }
              this.baseVariableService.deleteVariable(variable._oldName || variable.name, owner);
              if (!this.baseVariableService.variableCollection[owner][variable._oldName || variable.name]) {
                delete this.variableList[owner][variable._oldName || variable.name];
              }
              updateVariableTree = true;
            }
          });
        });
      } catch (exception) {
        if ((exception as any).type === 'variableNameAlreadyExists') {
          /*if exception thrown that variable name already exists, show error message*/
          // TO DO
          // toggleMessage(true, $rootScope.locale['MESSAGE_INSERT_VARIABLE_ALREADY_EXISTS'], "error");
          return resolve();
        }
      }

      /*if new variable is found to be saved, insert the name of the variable to the array for
       * callback implementing the onSave function*/
      if (this.baseVariableService.variablesForSave.indexOf(variableName) === -1) {
        this.baseVariableService.variablesForSave.push(variableName);
      }

      /*Save the variables in the file corresponding to active page and close the dialog*/
      if (refreshWS) {
        // TODO
        // $rootScope.$emit('save-workspace', false, invokeSave);
      } else {
        this.invokeSave(updateVariables, refreshWS, updateVariableTree).then(() => {
          resolve();
        });
      }
      // return resolve();
    });
  }

  updateMessageContent(type: string, caption: string) {
    let msgContent = {
      'type': type,
      'caption': caption
    };
    if (this.baseVariableService.createOnly) {
      this.addVariableDialogMsg = msgContent;
    } else {
      this.baseVariableService.variableDialogMsg = msgContent;
    }
  }

  checkJsEventInfo() {
    if (this.baseVariableService.jsEventsInfo.length) {
      const uniqueEventInfo = [...new Map(this.baseVariableService.jsEventsInfo.map((item: any) =>
        [item['variableName'], item])).values()]
      forEach(uniqueEventInfo, (evtObj) => {
        runtimeEventManager.emit('add-event-handler', evtObj);
      });
      this.baseVariableService.jsEventsInfo = [];
    }
  }

  //Saves the variables and reload the dialog
  saveAndReload(isVariableDialog: boolean = false) {
    this.checkJsEventInfo();
    const triggerSave = this.updateModelVarDataset(isVariableDialog);
    if (triggerSave === false) {
      return;
    }
    this.baseVariableService.disableDialogActions = true;
    this.saveVariablesInfo(false,true)
      .then(() => {
        this.baseVariableService.disableDialogActions = false;
        let selectedVariable = this.baseVariableService.selectedVariable,
          isLastVariableDeleted = get(selectedVariable, ['variableObject', 'remove']);
        // if (!isLastVariableDeleted) {
        //   this.preSelectedVariable = _.get(selectedVariable, 'variableObject');
        //   _.set(dialogParams.preSelectedVariable, 'category', _.get(selectedVariable, ['category']));
        // } else {
        //   dialogParams.preSelectedVariable = undefined;
        // }
        this.addVariableDialogMsg = null;
        this.baseVariableService.variableDialogMsg = null;
        this.baseVariableService.reloadVariablesSubject.next();
      }).catch(() => this.baseVariableService.disableDialogActions = false);
  };

  updateModelVarDataset(isVariableDialog: boolean): any {
    if (this.baseVariableService.selectedVariable?.category === 'wm.Variable' && this.baseVariableService.jsonEditorViewOption === 2) {
      let editorVal: any = this.baseVariableService.jsonTextEditor.value;
      try {
        this.baseVariableService.selectedVariable.variableObject['dataSet']= JSON.parse(editorVal);
      } catch (e) {
        /*Validation of "dataSet" for static variables.*/
        this.updateMessageContent('error', this.locale['LABEL_VARIABLE_PROPERTIES_DATASET'] + this.locale['MESSAGE_INSERT_VARIABLE_INVALID_DATASET']);
        return false;
      }
    }
  }

  //Saves the variables and closes the dialog
  saveAndClose(openScript?: boolean, updateVariables?: boolean, isVariableDialog: boolean = false) {
    this.checkJsEventInfo();
    const triggerSave = this.updateModelVarDataset(isVariableDialog);
    if (triggerSave === false) {
      return;
    }
    this.baseVariableService.disableDialogActions = true;
    this.saveVariablesInfo(openScript, updateVariables)
      .then(() => {
        this.baseVariableService.disableDialogActions = false;
        this.addVariableDialogMsg = null;
        this.baseVariableService.variableDialogMsg = null;
        this.close(isVariableDialog);
        this.notificationService.show("success", this.locale.MESSAGE_SUCCESS_TITLE, this.locale.MESSAGE_SUCCESS_SAVE_FILE_DESC);
        if(this.issuesService.isAPIIssuesTabOpened)
          this.eventManager.emitRefreshAPIIssues();
        this.baseVariableService.onEventOptionsChangeSubject.next(StudioUtils.getVarExp(this.baseVariableService.selectedVariable.variableObject.name));
      }).catch(() => this.baseVariableService.disableDialogActions = false);
  }

  invokeSave(updateVariables?: boolean, refreshWS?: boolean, updateVariableTree?: boolean) {
    return new Promise<void>((resolve, reject) => {
      this.baseVariableService.saveVariables(this.pageService.activePageName, updateVariables).then(() => {
        if (refreshWS) {
          // $rootScope.$emit('refresh-active-ws', false, onSaveSuccess);
        } else {
          this.addVariableDialogMsg = null;
          this.baseVariableService.variableDialogMsg = null;
          /*Update the tree with the newly added variable under the appropriate category(i.e., basic/service/live variables)*/
          if (updateVariableTree) {
            // $rootScope.$emit("update-variables-tree");
          }
          if (this.baseVariableService.prevSelectedVariable && this.baseVariableService.selectedEvt) {
            const selectedEvtExp = this.baseVariableService.prevSelectedVariable.variableObject[this.baseVariableService.selectedEvt]?.split(';');
            const index = selectedEvtExp?.includes("New Action") ? selectedEvtExp?.indexOf("New Action") : selectedEvtExp?.indexOf("New Variable");
            selectedEvtExp[index] =  StudioUtils.getVarExp(this.baseVariableService.selectedVariable.variableObject.name);
            let orgExp = selectedEvtExp?.join(';');
            this.baseVariableService.prevSelectedVariable.variableObject[this.baseVariableService.selectedEvt] = orgExp;
            this.baseVariableService.selectedVariable = this.baseVariableService.prevSelectedVariable;
          }
          // TODO
          // checkVariableCount($scope.filteredVariableList);
          // displayToaster({ "type": "success", "title": $rootScope.locale["MESSAGE_SUCCESS_TITLE"], "description": $rootScope.locale["MESSAGE_SUCCESS_SAVE_FILE_DESC"] });

          /* if success callback provided, call it */
          // TODO
          // Utils.triggerFn(dialogParams.onSave, variablesForSave, selectedVariable.isNew, isVariableEventChanged, openScript);
          // deffered.resolve();
          resolve();
        }
        runtimeEventManager.emit('check-expression-existence');
      }).catch((errorObj) => {
        if (errorObj?.error) {
          // TODO: check why ${0} is sent as {0}
          this.addVariableDialogMsg = {
            'type': 'error',
            'caption': replace(errorObj.error[0].message.replaceAll('{', '${'), errorObj.error[0].parameters)
          }
        }
        reject();
      });
    });
  };

  /*Function to update the variables tree in studio with the app and current page-level variables.*/
  updateVariablesTree(variable?: any) {
    let parentNode,
      wmVariables,
      activePageName = this.pageService.getActivePageName(),
      owner,
      varCollection: any = this.baseVariableService.variableCollection;
    /* Updating tree with passed variable values */
    if (variable) {
      /* update the local scope variable object */
      owner = variable.owner === 'App' ? 'App' : activePageName;
      parentNode = this.bindTreeService.getOwnerIndex(this.bindVariableService.variablesTree, variable.owner);
      varCollection[owner][variable.name] = variable;
      this.bindTreeService.addNodeToTree(variable, false, this.bindVariableService.variablesTree[parentNode].children, 'workSpace');
    } else {
      wmVariables = getAll();
      /* empty the existing variable collection */
      varCollection = {};
      varCollection[VARIABLE_CONSTANTS.OWNER.APP] = wmVariables[VARIABLE_CONSTANTS.OWNER.APP];
      varCollection[activePageName] = wmVariables[activePageName];
      this.bindVariableService.variablesPanelTree = this.bindTreeService.getRootStructure(varCollection);
      /* creating tree using saved variables */
      this.bindTreeService.buildVariables(varCollection, this.bindVariableService.variablesPanelTree,true, 'workSpace');
    }
  }


  /*function to close the dialog*/
  close(isVariableDialog?: boolean) {
    if (!isEmpty(this.baseVariableService.unsavedVariable)) {
      /*invoking the delete method from the variable service.*/
      this.baseVariableService.deleteVariable(this.baseVariableService.unsavedVariable);
    }
    this.baseVariableService.createOnly = false;
    this.baseVariableService.reloadVariablesSubject.next(isVariableDialog);
  }


  /*
  * create a new variable based on the category provided and displays its properties in the UI
  * @param {category} category under which new variable is to be created
  */
  createVariable(category: any, options: any) {
    // TODO: replace wm.Variable with defaultVarCategory
    // defaultVarCategory = variableCollectionType === 'call' ? "wm.NavigationVariable" : "wm.Variable",
    let variableCategory = stringStartsWith(category, "wm.") ? category : '"wm.Variable"',
      createdVariable;

    /* call base service function to create the variable */
    createdVariable = this.baseVariableService.createVariable(variableCategory, options);

    /* Show properties of the newly created variable */
    this.getTypesOfSelectedVariables(variableCategory, createdVariable, true, options);
  };

  // This function validates if property is required and valid.
  isRequiredProp(selectedVariable: any, propObj: any, propKey: any) {
    let target;
    //For navigation variable, check the target value in the variableObject.databinding
    if (includes(this.navigationTypes, propKey)) {
      target = find(selectedVariable.variableObject.dataBinding, { 'target': propKey });
      return (target && !target.value);
    }
    return propObj.required && !selectedVariable.variableObject[propKey];
  }

  /**
   * function to validate property of a variable
   * @param selectedVariable, pass the selected variable
   * @param propObj, these are the property objects related to the selected variable
   * @param propertyName this is the name of the property being validated
   * @returns {boolean}
   */
  validateVariableProprty(selectedVariable: any, propObj: any, propertyName: any, errMsgObj: any): any {
    let nameRegEx;
    /* if property object not found continue to remaining properties  */
    if (!propObj) {
      return;
    }

    if (this.isRequiredProp(selectedVariable, propObj, propertyName)) {
      errMsgObj.showError = true;
      errMsgObj.errorMsg = this.getVariablePropertyName(propertyName) + this.locale['MESSAGE_INSERT_VARIABLE_PROPERTY_REQUIRED'];
      return true;
    }

    /* Show required error message for specified property */
    if (propObj.pattern) {
      nameRegEx = new RegExp(propObj.pattern);
      if (!nameRegEx.test(selectedVariable.variableObject[propertyName])) {
        /* TODO: special case for deleting default navigation variables, to be removed */
        errMsgObj.showError = true;
        errMsgObj.errorMsg = this.getVariablePropertyName(propertyName) + this.locale['MESSAGE_INSERT_VARIABLE_PROPERTY_PATTERN'];
        return true;
      }
    }
  }

  /**
 * Returns property names of variables which are bwing displayed on UI
 * @param propertyName, the internal property name is passed as parameter
 * @returns {*}
*/
  getVariablePropertyName(propertyName: any) {
    let variableLocalePropertyObj = get(this.locale, 'LABEL_VARIABLE_PROPERTY')[this.baseVariableService.selectedVariable.category];
    if (this.baseVariableService.selectedVariable.variableObject.category === "wm.LiveVariable" && propertyName === "onBeforeUpdate") {
      return get(this.locale, 'LABEL_VARIABLE_PROPERTIES_ONBEFORE_' + this.baseVariableService.selectedVariable.variableObject.operation?.toUpperCase());
    }
    return get(this.baseVariableService.selectedVariable, 'propertyObj[\"' + propertyName + '\"]displayName') ||
      variableLocalePropertyObj && variableLocalePropertyObj[propertyName] ||
      get(this.locale, 'LABEL_VARIABLE_PROPERTIES_' + propertyName.toUpperCase()) ||
      capitalize(propertyName);
  }


  /**
   *  Validates init properties of the variable when variable has not been created
   * @param errMsgObj, this is the object that contains error message
   * @returns {boolean}
   */
  validateVariableInitProperties(errMsgObj: any) {
    let hasError = false;
    forEach(this.initVariableObj["propertyObj"], (property): any => {
      if (!property.hide) {
        if (!property.modelObj[property.modelKey]) {
          hasError = true;
          errMsgObj.showError = true;
          errMsgObj.errorMsg = property.displayName + this.locale['MESSAGE_INSERT_VARIABLE_PROPERTY_REQUIRED'];
          return false;
        }
      }
    });
    return hasError;
  }

  /* function to validate the selected variable before saving */
  validateSelectedVariable() {
    let propObj,
      hasValidationError: any = false,
      errMsgObj = {},
      selectedVariable = this.baseVariableService.selectedVariable;
    //If the variable has been created then validate the selected variable properties
    if (selectedVariable) {
      /* Removing spaces from variable name */
      if (selectedVariable.variableObject['name']) {
        selectedVariable.variableObject['name'] = selectedVariable.variableObject['name'].replace(/\s/g, '');
      }

      /*Validation of "dataSet" for static variables.*/
      if (selectedVariable.category === 'wm.Variable' && selectedVariable.invalidDataset) {
        return {
          "showError": true,
          "errorMsg": this.locale['LABEL_VARIABLE_PROPERTIES_DATASET'] + this.locale['MESSAGE_INSERT_VARIABLE_INVALID_DATASET']
        };
      }

      selectedVariable.propertyNames = keys(selectedVariable.propertyObj);

      //validation done only for properties and not for data and event propertyGroups
      forEach(this.propertyGroups[0].subGroups, (subGroup): any => {
        if (hasValidationError) {
          return false;
        }
        forEach(subGroup.properties, (propertyName): any => {
          propObj = selectedVariable.propertyObj[propertyName];
          hasValidationError = this.validateVariableProprty(selectedVariable, propObj, propertyName, errMsgObj);
          if (hasValidationError) {
            return false;
          }
        });
      });

      //if it has some validation error return error message object
      if (hasValidationError) {
        return errMsgObj;
      }

      //else check for name valiation error
      else {
        propObj = selectedVariable.propertyObj['name'];
        hasValidationError = this.validateVariableProprty(selectedVariable, propObj, 'name', errMsgObj);
        if (hasValidationError) {
          return errMsgObj;
        }
      }

      // Return if variable already exists - checking for _oldName to process validation when name has been changed and compare if the old name changed is equal to the new name being case insensitive.
      if (selectedVariable.variableObject._oldName && (!isDuplicateName([selectedVariable.variableObject._oldName], selectedVariable.variableObject['name'], true)) && this.baseVariableService.isExists(selectedVariable.variableObject['name'], true)) {
        return {
          "showError": true,
          "errorMsg": this.locale['MESSAGE_INSERT_VARIABLE_ALREADY_EXISTS']
        };
      }
    }
    //If the variable is not created validate init properties of the variable
    else {
      hasValidationError = this.validateVariableInitProperties(errMsgObj);
      if (hasValidationError) {
        return errMsgObj;
      }
    }

    /* no error found */
    return { "showError": false };
  }

  changeVarInstance(_sameScope?: boolean) {
    let variableName = this.baseVariableService.selectedVariable?.variableObject.name;
    let varOldName = this.baseVariableService.selectedVariable?.variableObject._oldName;
    const collection = this.baseVariableService.variableInstanceCollection;
    // if variable name is present check for variable name in variablecollection else check for oldName (in case Var name modified)
    if (collection[this.ownerApp][variableName] || collection[this.ownerApp][varOldName]) {
      const existingVar = collection[this.ownerApp][variableName] ? variableName : varOldName;
      if (_sameScope) {
        collection[this.ownerApp][variableName] = collection[this.ownerApp][existingVar];
      } else {
        collection[this.pageService.activePageName][variableName] = collection[this.ownerApp][existingVar];
      }
      delete collection[this.ownerApp][existingVar];
    } else if (collection[this.pageService.activePageName][variableName]  || collection[this.pageService.activePageName][varOldName] ) {
      const existingVar = collection[this.pageService.activePageName][variableName] ? variableName : varOldName;
      if (_sameScope) {
        collection[this.pageService.activePageName][variableName] = collection[this.pageService.activePageName][existingVar];
      } else {
        collection[this.ownerApp][variableName] = collection[this.pageService.activePageName][existingVar];
      }
      delete collection[this.pageService.activePageName][existingVar];
    }
  }

  /*
* handles the owner change of the selected variable
* it is performed only if the selected variable is not a new variable
* @param {none}
*/
  changeVariableOwner() {
    /* if a new variable owner changed, return */
    if (this.baseVariableService.selectedVariable.isNew) {
      if (this.baseVariableService.selectedVariable.variableObject.owner === this.variableOwnerProxy) {
        return;
      }
      this.baseVariableService.selectedVariable.variableObject.owner = this.variableOwnerProxy;
      // change event list
      if (isEventCallbackVariable(this.baseVariableService.selectedVariable.category)) {
        this.addVariablesToEventOptions(this.baseVariableService.selectedVariable.variableObject);
      }
      this.changeVarInstance();
      return;
    }

    let variableObject = this.baseVariableService.selectedVariable.variableObject,
      variableName = variableObject.name,
      variableContext = variableObject.owner,
      targetContext = variableContext === this.ownerApp ? this.pageService.activePageName : this.ownerApp;

    if (this.variableList[targetContext] && this.variableList[targetContext][variableName]) {
      this.continueMessage = replace(this.locale.MESSAGE_OVERWRITE_EXISTING_VARIABLE, [variableName, targetContext]);
      this.showContinueMsg = true;
    } else {
      this.changeVarInstance();
      this.changeOwner();
    }
  };

  /* function to initialize variable list from the Variables service */
  initVariableList() {
    /* Holds all the variables available with base service */
    /* Making a copy of saved variables to avoid changing in it directly.
      Hence a proxy is created and exposed on the UI. It can be manipulated before updating
      the saved variables list */
    this.variableList = getClonedObject(getByContext([this.ownerApp, this.pageService.activePageName]));
  }

  changeOwner() {
    let selectedVariable = this.baseVariableService.selectedVariable,
      variableObject = selectedVariable.variableObject,
      variableName = variableObject.name,
      variableOwner = variableObject.owner;

    /* transform the created variable in format required by service */
    variableObject.category = selectedVariable.category;
    if (variableOwner === this.ownerApp) {
      this.baseVariableService.selectedVariable.variableObject.owner = this.ownerPage;
      this.variableList[this.pageService.activePageName][variableName] = variableObject;
      delete this.variableList[this.ownerApp][variableName];
      // Assign the prvious owner to the variable only if there is no prev owner
      if (!variableObject._prevOwner) {
        variableObject._prevOwner = this.ownerApp;
      }
    } else {
      this.baseVariableService.selectedVariable.variableObject.owner = this.ownerApp;
      this.variableList[this.ownerApp][variableName] = variableObject;
      delete this.variableList[this.pageService.activePageName][variableName];
      // Assign the prvious owner to the variable only if there is no prev owner
      if (!variableObject._prevOwner) {
        variableObject._prevOwner = this.pageService.activePageName;
      }
    }
    //if the variable is spinner type reassign the options
    if (isSpinnerType(variableObject.category)) {
      this.baseVariableService.selectedVariable.propertyObj.spinnerContext.options = this.getSpinnerWidgets(this.baseVariableService.selectedVariable.variableObject);
    }

    this.baseVariableService.markUpdated();
    // change event list
    if (isEventCallbackVariable(this.baseVariableService.selectedVariable.category)) {
      this.addVariablesToEventOptions(this.baseVariableService.selectedVariable.variableObject);
    }
    this.changeOwnerSubject.next();
  }


  /*Function to handle variable name change*/
  changeVariableName(variableNameProxy: any) {
    let variableObject = this.baseVariableService.selectedVariable.variableObject;
    if (variableObject._oldName) {
      if (variableObject._oldName === variableNameProxy) {
        //Removing oldName if name is changed back to same name
        variableObject._oldName = undefined;
      }
    } else {
      //Storing oldName in scope as it required while saving
      variableObject._oldName = variableObject.name;
    }
    variableObject.name = variableNameProxy;
    this.baseVariableService.disableDialogActions = false;
    // updating the instanceCollection with the updated variable name
    this.changeVarInstance(true);
  };

  getTypesOfSelectedVariables(variableCategory: any, variableObject: any, newVariableFlag?: boolean, options?: any, resetActiveTab: boolean = true):any{
    if(variableObject && (variableObject.liveSource|| variableObject.service)){
      let service = variableObject.liveSource|| variableObject.service
      this.typeService.getDataTypesByService(service , true).then(()=>{
        this.showSelectedVariableProperties(variableCategory,variableObject,newVariableFlag,options,resetActiveTab);
      })
    }else {
      this.showSelectedVariableProperties(variableCategory,variableObject,newVariableFlag,options,resetActiveTab);
    }
  }
  /* function to change the selected variables class based on the variable selected by user*/
  showSelectedVariableProperties(variableCategory: any, variableObject: any, newVariableFlag?: boolean, options?: any, resetActiveTab: boolean = true): any {
    this.baseVariableService.variableDialogMsg = null;
    if (resetActiveTab) {
      this.currentSelectedTabView = '';
    }
    let selectedVariable = this.baseVariableService.selectedVariable || {}, validation, variableMetaInfo;

    /*
     * Validate previous variable before moving on to next variable,
     * if wrong values are found, they will be restored to previous
     * correctly saved values
     */
    if (selectedVariable.variableObject && !selectedVariable.isNew) {
      // validate the previous variable
      validation = this.validateSelectedVariable();
      if ((validation as any).showError) {
        // toggleMessage(true, (validation as any).errorMsg, "error"); -- To do
        return false;
      }
      // remove the active flag of the previous variable
      this.baseVariableService.selectedVariable.variableObject.active = false;
    }

    /* flag used by basic variable controller */
    this.variableChanged = true;

    selectedVariable = {};
    if (newVariableFlag) {
      selectedVariable.isNew = true;
      selectedVariable.editMode = true;
    } else {
      selectedVariable.editMode = false;
      selectedVariable.serviceType = getVariableServiceType(variableObject);
      variableMetaInfo = this.baseVariableService.getVariableMetaInfo(variableObject);
      selectedVariable.serviceSubType = variableMetaInfo.subType;
      // Meta info for the variable
      selectedVariable.metaInfo = variableMetaInfo.info;
    }

    /* Hide the errors if new variable is selected */
    // toggleMessage(false); --- TO DO

    /* assign new properties of the selected variable */
    selectedVariable.category = variableCategory;
    selectedVariable.variableObject = variableObject;
    selectedVariable.propertyObj = this.propertyFactory.getPropertyMap(variableCategory);
    selectedVariable.propertyNames = keys(selectedVariable.propertyObj);

    /* assign the model strings to each propertyMapObject */
    forEach(selectedVariable.propertyObj, (property, name) => {
      property.modelObj = selectedVariable.variableObject;
      if (property.type === 'list' && selectedVariable.category === 'wm.Variable') { // TODO: check for category check improvement
        property['groupBy'] = 'category';
      }
      property.modelKey = name;
      property.disabled = property.isprimary ? (property.isprimary && !this.baseVariableService.createOnly) : property.disabled;
      // remove displayName if assigned by a previous controller (displayName is used only in case of bindings)
      if (property.displayName) {
        property.displayName = undefined;
      }
    });

    selectedVariable.properties = Object.keys(selectedVariable.propertyObj);

    /* if variable is created in a prefab project, remove "Application" from owner options */
     if (this.projectService.isPrefabType()) {
       delete selectedVariable.propertyObj.owner.options.App;
     }
     //TODO
     //else if (this.wsManager.getActiveWSCategory() !== 'PAGE') {
       /* if active workspace type is not html, remove "Page" from owner options */
       //delete selectedVariable.propertyObj.owner.options.Page;
       //selectedVariable.variableObject.owner = this.ownerApp;
       //this.variableOwnersList = [this.ownerApp];
     //}
     else {
    selectedVariable.propertyObj.owner.options.Page = "LABEL_PAGE";
    }
    /*Assigning selected variable's properties to proxy variables*/
    this.variableOwnerProxy = selectedVariable.variableObject.owner;
    this.variableNameProxy = selectedVariable.variableObject.name;
    this.showContinueMsg = false;

    // set the active flag of the selected variable
    variableObject.active = true;

    /* assign the selected variable to scope variable */
    this.baseVariableService.selectedVariable = selectedVariable;
    if (newVariableFlag) {
      this.baseVariableService.createServiceInstance(this.pageService.activePageName, selectedVariable.variableObject.name, selectedVariable.category, selectedVariable);
    }
    this.selectedVarService = this.baseVariableService.getSelectedVariableInstance();
    if (this.selectedVarService?.triggeredSubscription && (variableObject.category === 'wm.LogoutVariable' || variableObject.category === 'wm.LoginVariable' || variableObject.category === 'wm.TimerVariable'))
      this.selectedVarService.triggeredSubscription = false;
    if (this.selectedVarService) {
      const propSubject: any = this.selectedVarService.propertyGroupChangeSubject ? this.selectedVarService.propertyGroupChangeSubject : this.selectedVarService[this.baseVariableService.variableServiceMapper[this.selectedVarService.category]]?.propertyGroupChangeSubject;
      propSubject?.subscribe(() => {
        if ((!this.currentSelectedTabView && !this.baseVariableService.createOnly) || (this.baseVariableService.createOnly && this.baseVariableService.selectedVariable.category === 'wm.Variable')) {
          // TO DO - check if debounce is needed
          this.propertyGroups = cloneDeep(this.baseVariableService.propertyGroups)
        }
      });
    }


    // assign extra options for controller initialization, will be used in the respective controllers
    this.baseVariableService.selectedVariable.configOptions = options;

    /* process initial binding fields according to variable category */
    this.selectedVarService?.__getVariableDependencies();

    if (this.baseVariableService.selectedVariable.metaInfo) {
      this.splitSource = this.baseVariableService.selectedVariable.metaInfo.split('/');
    } else {
      this.splitSource = undefined;
    }
    /* adding the variable to event options only if the selected variable is an event callback variable */
    if (isEventCallbackVariable(selectedVariable.category)) {
      this.addVariablesToEventOptions(selectedVariable.variableObject);
    }
    //check if the variable has spinner in config
    if (isSpinnerType(selectedVariable.category)) {
      selectedVariable.propertyObj.spinnerContext.options = this.getSpinnerWidgets(selectedVariable.variableObject);
    }
    /* if selectedVariable is of type primitive then jsonTextEditor view is not applicable */
    if(this.baseVariableService.selectedVariable.isPrimitiveType && this.baseVariableService.jsonEditorViewOption === 2){
      this.baseVariableService.jsonEditorViewOption = 1;
    }
    /* update jsonTextEditor value according to the selectedVariable */
    else if(this.baseVariableService.jsonEditorViewOption === 2){
      this.baseVariableService.jsonTextEditor.value = JSON.stringify(this.baseVariableService.selectedVariable.variableObject['dataSet'],undefined,2);
    }
    this.eventManager.emitUpdateVariableTabView();
  };

  /**
 * Function to get the spinner widgets in the page for the spinner context property
 * pageSpinnerWidgets is a global variable object which contains the spinner widgets map
 *
 * @param options this is the object reference of the spinner context property from the domscope
 */
  getSpinnerWidgets(variableObj: any) {
    let spinnerWidgets,
      options: any = {
        'page': 'page'
      };

    //if the platform type is reactnative then return only page
    if (this.projectService.isNativeMobileApplicationType()) {
      return options;
    }

    //if the variable owner is application then return only page
    if (variableObj.owner === this.ownerApp) {
      return options;
    }
    //if pageSpinnerWidgets is already prepared return it back
    if (isEmpty(this.pageSpinnerWidgets)) {
      spinnerWidgets = byType('spinner-widgets');
      forEach(spinnerWidgets, (value, key) => {
        options[key] = key;
      });
      this.pageSpinnerWidgets = options;
    }
    return this.pageSpinnerWidgets;
  }


  /*
  * Method to add the existing service and live variables as event operations to the provided variable.
  * except the provided variable name which must not be added to it's own event operations.
  * @param {variableName} name of the variable against which the event options will be added
  */
  addVariablesToEventOptions(variable: any) {
    /*obtaining currently selected variable name to retrieve variables other than the variable name provided.*/
    let variableList = StudioUtils.getVariableOptions(variable.name, (variable.owner === this.ownerApp ? this.ownerApp : undefined)),
      selectedVariable = this.baseVariableService.selectedVariable,
      defaultEvents = WIDGET_CONSTANTS.EVENTS_OPTIONS,
      variablePropertyObj = selectedVariable.propertyObj,
      newOptions: any = [];

    // TO DO
    let dialogOptions: any = StudioUtils.getDialogOptions();/*initializing dialog options*/
    let prefabEventOptions = StudioUtils.getPrefabEventOptions();
    //Pushing default events
    forEach(defaultEvents, (opt) => {
      newOptions.push({ name: opt, category: 'Default' });
    });

    /*iterating over the variable list to add variable names to the currently selected variable's event options.*/
    forEach(variableList, (curObj) => {
      /* add the variable to event list */
      if (variable.owner === this.ownerApp) {
        curObj.category = curObj.category + ' (App Only)';
      }
    });

    newOptions = newOptions.concat(variableList, dialogOptions, prefabEventOptions);
    forEach(VARIABLE_CONSTANTS.EVENTS, (event) => {
      /* proceed if the variable has current event in its properties */
      if (variablePropertyObj[event]) {
        variablePropertyObj[event].options.length = 0;
        Array.prototype.push.apply(variablePropertyObj[event].options, newOptions);
      }
    });
    /*assigning the cloned object reference back to the selected variable object.*/
    this.baseVariableService.selectedVariable.propertyObj = variablePropertyObj;
  }

  /*
   * returns true if the provided variable input binding structure needs to be shown in expanded view in"binding dialog"
   * currently true for "wm.Variable", "wm.ServiceVariable", "wm.LiveVariable", "wm.LoginVariable"
   */
  isNestedBindingRequired = (category: any) => {
    let categories = ["wm.Variable", "wm.ServiceVariable", "wm.CrudVariable", "wm.LiveVariable", "wm.LoginVariable", "wm.WebSocketVariable", "wm.DeviceVariable"];
    return (categories.indexOf(category) !== -1);
  }

  /*
   * opens the bind variable dialog to bind selected property of current variable
   * @param {propertyDetails} object having details of selected property
   * @param {propertyName} name of the selected property
   */
  async openBindVariableDialog(propertyDetails: any, propertyName: any, callbackFunction?: any, isVariableBindMode?: any) {
    if (isNil(isVariableBindMode)) {
      isVariableBindMode = true;
    }
    let nestedBindMode = this.isNestedBindingRequired(this.baseVariableService.selectedVariable.category);

    /* TODO(On_Demand_Binding): remove this as type ref will keep account */
    let selectedVariable = this.baseVariableService.selectedVariable,
      variableObject = selectedVariable.variableObject,
      bindings = variableObject.dataBinding,
      variablePackage;

    if (variableObject.category === "wm.LiveVariable" && variableObject.operation === "read") {
      bindings = this.baseVariableService.getAllFilterExpressions(variableObject.filterExpressions);
    }
    /* If nestedBindMap required, prepare bind-map to represent tree in bind dialog */
    if (nestedBindMode) {
      variablePackage = variableObject.category === 'wm.LiveVariable' ? variableObject.package : variableObject.type;
      selectedVariable.bindMap = [{ 'name': 'dataBinding', 'value': '', 'type': variablePackage, 'fields': [] }];
      if (selectedVariable.category === 'wm.Variable') {
        if (selectedVariable.isPrimitiveType || selectedVariable.isPreBuiltType) {
          let fieldsInfo: any = (await this.bindTreeService.getTreeForVar(variableObject, false, { 'isBindingTree': true }))[0];
          selectedVariable.bindMap[0].fields = fieldsInfo.fields;
        } else {
          let bindReference = selectedVariable.bindMap[0];
          this.bindTreeService.getBindMap(selectedVariable.variableObject.type, bindReference);
        }
      } else if (selectedVariable.category === 'wm.CrudVariable') {
        forEach(bindings[selectedVariable.currentTab], (bindingObj) => {
          /* putting the first level nodes only in bindMap(leaving nodes after first level and dataBinding node too) */
          if (bindingObj.target !== "dataBinding" && bindingObj.target.indexOf(".") === -1) {
            var bindReference = selectedVariable.bindMap[0].fields[selectedVariable.bindMap[0].fields.push({
              "name": bindingObj.target,
              "type": bindingObj.type,
              "format": (propertyDetails.displayName === bindingObj.target && propertyDetails.format),
              "isList": bindingObj.isList
            }) - 1];
            this.bindTreeService.getBindMap(bindingObj.type, bindReference);
          }
        });
      } else {
        forEach(bindings, (bindingObj) => {
          /* putting the first level nodes only in bindMap(leaving nodes after first level and dataBinding node too) */
          if (bindingObj.target !== "dataBinding" && bindingObj.target.indexOf(".") === -1) {
            let bindReference = selectedVariable.bindMap[0].fields[selectedVariable.bindMap[0].fields.push({
              "name": bindingObj.target,
              "type": bindingObj.type,
              "format": (propertyDetails.displayName === bindingObj.target && propertyDetails.format),
              "isList": bindingObj.isList
            }) - 1];
            this.bindTreeService.getBindMap(bindingObj.type, bindReference);
          }
        });
      }
    }
    let columns = this.typeService.getFieldsForType(selectedVariable.variableObject.package, { 'filter': 'terminal', 'getFieldInfo': true });
    let existingBindings = (variableObject.category === "wm.LiveVariable" && variableObject.operation === "read")
      ? this.baseVariableService.getAllPropertyBindings(columns, this.baseVariableService.getAllFilterExpressions(variableObject["filterExpressions"]))
      : variableObject.dataBinding;

    this.bindVariableService.dialogParams = {
      bindMode: isVariableBindMode ? 'variable' : '',
      nestedBindMode: nestedBindMode,
      activePageName: this.pageService.activePageName,
      addCustomClass: true,
      activeProperty: {
        propertyOwnerName: this.baseVariableService.selectedVariable.variableObject.name,
        variableOwner: this.baseVariableService.selectedVariable.variableObject.owner,
        propertyDetails: propertyDetails,
        name: propertyDetails.displayName || propertyName,
        bindMap: this.baseVariableService.selectedVariable.bindMap,
        existingBindings: existingBindings
      },
      boundEntity: propertyDetails.modelObj[propertyDetails.modelKey],
      message: this.locale.MESSAGE_HELP_VARIABLE_BIND_HINT,
      propertyBindCallback: (boundVariable: any, boundProperty: any, boundVariableType: any) => {
        if (isFunction(callbackFunction)) {
            callbackFunction(propertyDetails, boundVariable);
        }
        if (!nestedBindMode) {
          /* if normal mode, assign the bound value to the target property model */
          propertyDetails.modelObj[propertyDetails.modelKey] = boundVariable;
        } else {
          /* new bindings are made, re-render the UI for bindings */
          this.baseVariableService.addBindingsToProperties();
        }
        this.baseVariableService.markUpdated();
      },
    }
    this.dialogService.open("BindVariable");
  }

   /* initializes the properties list used by the view */
  initVariablePropertyList() {
    let mainGroups = [];
    /* getting property list for property panel */
    for (let i = 0; i < this.groups.length; i += 1) {
      let group = this.groups[i];
      if (!group.parent) {
        this.map[group.name] = [];
        mainGroups.push(group);
        group.subGroups = this.map[group.name];
      } else {
        this.map[group.parent].push(group);
      }
    }
    if (!isEqual(this.propertyGroups, mainGroups)) {
      this.propertyGroups = mainGroups;
      this.baseVariableService.propertyGroups = this.propertyGroups;
    }
  }
}
